module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_zoyi_m.4a584ff672d77bc6253bf18407c7ab15.png";